import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FailedAttempts() {
  const attempts = [{
    title: "Confiar en la 'fuerza de voluntad'",
    desc: 'falla porque es un recurso que se agota cuando estás cansado o estresado.'
  }, {
    title: 'Borrar el historial',
    desc: 'no sirve si el acceso sigue a dos clics de distancia en tu bolsillo.'
  }, {
    title: "Prometer que 'mañana será diferente'",
    desc: 'es la mentira que tu cerebro adicto usa para silenciar tu conciencia hoy.'
  }, {
    title: 'Intentar dejar el hábito sin sustituir',
    desc: 'la química cerebral deja un vacío que el aburrimiento siempre termina llenando.'
  }];
  return <section className="py-20 px-6 bg-[#09090b]" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <FadeIn data-id="element-133">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-12" data-id="element-134">
            Por qué lo que intentaste{' '}
            <span className="text-red-500" data-id="element-135">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-136">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-137">
              <div className="flex items-start gap-4 bg-zinc-900/50 border border-zinc-800/50 rounded-xl p-6" data-id="element-138">
                <div className="mt-1 bg-red-500/10 p-2 rounded-lg shrink-0" data-id="element-139">
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-140" />
                </div>
                <p className="text-lg text-zinc-300 leading-relaxed" data-id="element-141">
                  <strong className="text-white font-semibold" data-id="element-142">
                    {attempt.title}
                  </strong>{' '}
                  {attempt.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}